<template>
    <div :class="{ 'dark': store.state.global.isDark }">
        <Head title="Join My League on Racing Stars!">
            <meta inertia property="og:title" content="Join My League on Racing Stars!" />
            <meta inertia property="og:description" content="Click here to sign up/login and join the league..." />
            <meta inertia property="og:image" :content="asset('images/og-image.jpg')" />
        </Head>

        <div class="h-screen relative overflow-hidden">
            <div class="relative">
                <main>
                    <slot></slot>
                </main>
            </div>
        </div>
    </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import ApplicationLogo from '@/Jetstream/ApplicationLogo'
import { ref, reactive, onMounted, computed, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import moment from 'moment'

export default {
    props: {
        user: Object,
        racingstars: Object,
    },
    components: {
        ApplicationLogo,
        Head,
        Link,
    },

    setup(props) {
        
        /*
        |--------------------------------------------------------------------------
        | Properties
        |--------------------------------------------------------------------------
        */
        /**
         * The VueX store.
         * 
         * @type {Object}
         */
        const store = useStore()

        /**
         * Formatter function required to format currencies/prices correctly.
         * 
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })


        /**
         * Mounted.
         */
        onMounted(() => {
            store.commit('setDarkModeIfUndefined')

            if (props.user && props.racingstars.env === 'production') {
                gtm.trackEvent({
                    event: 'User Logged In',
                    user: {
                        name: user.name,
                        email: user.email,
                        id: user.uuid,
                        created_at: user.created_at_timestamp,
                        mobile: user.mobile,
                        user_hash: user.hash,
                        avatar: user.profile_photo_url,
                    }
                });
            }
        })

        /*
        |--------------------------------------------------------------------------
        | Methods
        |--------------------------------------------------------------------------
        */

        return {
            store,
            formatter,
            moment,
        }
    }
}

</script>
